export default __webpack_public_path__ + "static/MerriweatherSans-LightItalic-41c24c845d1af547d43be81be69745ee.ttf";